import store from '@/store'
import moment from 'moment'

const getters = {
  ui_modal_bible_auth: state => state.ui.modal_bible_auth.opened,
  token: state => state.auth.token,
  name: state => state.auth.name,
  level: state => state.auth.level,
  id: state => state.auth.id,
  verse(state) {
    return params => {
      if (params.code) {
        for (let i = 0; i < store.state.data.current.chapter.verses.length; i++) {
          if (params.code === store.state.data.current.chapter.verses[i].code) {
            return store.state.data.current.chapter.verses[i]
          }
        }
      }
      return null
    }
  },
  bible_search_options(state) {
    const bibleOld = [ 'old' ]
    const bibleNew = [ 'new' ]
    const bibleApo = [ 'apo' ]
    let options = [
      {
        value: bibleOld.concat(bibleNew).join(','),
        text: '全書',
      },
      {
        value: bibleOld.join(','),
        text: '旧約',
      },
      {
        value: bibleNew.join(','),
        text: '新約',
      },
    ]
    if (state.setting.apocrypha.value) {
      options[0].value = bibleOld.concat(bibleNew, bibleApo).join(',')
      options.push({
        value: bibleApo.join(','),
        text: '旧約続編',
      })
    }
    return options
  },
  ticket_search_options(state) {
    let options = [
    ]
    for (let i = moment().year(); i >= 2018; i--) {
      options.push({
        value: i,
        text: '利用期間：' + i + '年',
      })
    }
    return options
  },
  bible_index(state, getters) {
    return indexes => {
      if (indexes.bible) {
        for (let i = 0; i < state.data.info.bibles.length; i++) {
          if (indexes.bible === state.data.info.bibles[i].code) {
            return i
          }
        }
      }
      return null
    }
  },
  bible(state, getters) {
    return indexes => {
      const index = getters.bible_index(indexes)
      if (Number.isInteger(index)) {
        return state.data.info.bibles[index]
      }
      return null
    }
  },
  book_index(state, getters) {
    return (indexes, books) => {
      const _bible = getters.bible(indexes)
      if (_bible) {
        if (indexes.book) {
          for (let i = 0; i < _bible.bible_books.length; i++) {
            if (indexes.book === _bible.bible_books[i].code) {
              return i
            }
          }
        }
      }
      return null
    }
  },
  book(state, getters) {
    return (indexes, books) => {
      const _bible = getters.bible(indexes)
      const _book_index = getters.book_index(indexes)
      if (Number.isInteger(_book_index)) {
        return _bible.bible_books[_book_index]
      }
      return null
    }
  },
}
export default getters

